import {FC} from 'react';

import {TWO_GIS_DOMAIN} from '../../provider/domain-config/domain-config-helper';
import {DomainNameEnum} from '../../provider/domain-config/domain-config-type';
import {LicenseType} from '../../provider/license/license-provider-type';
import {getLocalizedString} from '../../provider/locale/library/localization-helper';
import {enUs} from '../../provider/locale/translation/en-us/data';
import {LangKeyType} from '../../provider/locale/translation/type';

export function makeHardReload(): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.location.reload();
}

export function isEnabledForDomainAndDoubleGis(options: {
    isDomainFeatureEnabled: boolean;
    isFeatureEnabled: boolean;
    domainName: DomainNameEnum | string;
}): boolean {
    if (options.domainName === DomainNameEnum.twoGis) {
        return options.isDomainFeatureEnabled && options.isFeatureEnabled;
    }

    return options.isDomainFeatureEnabled;
}

export function isEnabledForDomainAndDoubleGisWhiteLabel(options: {
    isDomainFeatureEnabled: boolean;
    isFeatureEnabled: boolean;
    domainName: DomainNameEnum | string;
}): boolean {
    const isDoubleGisWhiteLabel = options.domainName.includes(TWO_GIS_DOMAIN);

    if (isDoubleGisWhiteLabel) {
        return options.isDomainFeatureEnabled && options.isFeatureEnabled;
    }

    return options.isDomainFeatureEnabled;
}

export function getFeatureOrLandingPage(options: {
    license?: LicenseType;
    activationComponent: FC<Record<string, unknown>>;
    pageComponent: FC<Record<string, unknown>>;
}): FC<Record<string, unknown>> {
    const {license, activationComponent, pageComponent} = options;

    if (!license || (!license.isActive && license.canActivateTrial)) {
        return activationComponent;
    }

    return pageComponent;
}

export function getMenuItemNameForAnalytics(langKey: LangKeyType, valueMap?: Record<string, string>): string {
    return getLocalizedString(langKey, enUs, valueMap);
}
